import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import PriceRolloutChoice from "../../Catalog/PriceRolloutChoice";

function SubmitConfirmation({
  handleClose,
  handleSave,
  submitLoader,
  warnActiveSubs = false,
  /** The offers this save touches — needed to list who could be moved. */
  priceIds = [],
}) {
  // The rollout choice lives HERE rather than in a dialog of its own. An admin
  // asked to confirm a price change that affects paying customers should see
  // the warning and the choice together — clicking through two dialogs made
  // the second one easy to miss entirely.
  const [rollout, setRollout] = useState({
    mode: "new_only",
    subscription_ids: [],
    note: null,
  });
  const [rolloutValid, setRolloutValid] = useState(true);

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      // The rollout choice carries a table of customers, so the dialog has to
      // be wide when it is shown and stay compact when it is not.
      maxWidth={warnActiveSubs ? "md" : "sm"}
      fullWidth={warnActiveSubs}
      sx={{
        zIndex: 3000,
      }}
      PaperProps={{
        sx: {
          borderRadius: "14px",
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "2b6cb0",
        }}
      >
        Confirm Submission
      </DialogTitle>

      <DialogContent>
        {warnActiveSubs && (
          <div
            style={{
              border: "1px solid #f5c26b",
              background: "#fff8ec",
              color: "#92400e",
              borderRadius: 10,
              padding: "10px 12px",
              marginBottom: 16,
              fontWeight: 600,
              lineHeight: 1.4,
            }}
          >
            ⚠ You changed unit prices on a plan that has active subscriptions.
            Nothing re-prices on its own — choose below which customers this
            new price is for, and see when it would reach them.
          </div>
        )}
        You are about to submit the marketplace details.
        <br />
        <br />
        {warnActiveSubs ? (
          <>
            Plans, configurations and the price buyers are quoted change as
            soon as you save. Existing customers move only if you choose them
            below, and never before their own price validity runs out.
          </>
        ) : (
          <>
            Any changes made to plans, unit prices, or configurations will be
            applied immediately.
          </>
        )}
        <br />
        <br />
        Do you want to continue?

        {warnActiveSubs && (
          <div style={{ marginTop: 18, borderTop: "1px solid #e2e8f0", paddingTop: 14 }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                color: "#2d3748",
                marginBottom: 6,
              }}
            >
              Who is this price for?
            </div>
            <PriceRolloutChoice
              priceIds={priceIds}
              busy={submitLoader}
              onChange={setRollout}
              onValidityChange={setRolloutValid}
            />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          disabled={submitLoader}
          onClick={handleClose}
          sx={{
            color: "#4A5568",
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={() => handleSave(warnActiveSubs ? rollout : null)}
          variant="contained"
          disabled={submitLoader || (warnActiveSubs && !rolloutValid)}
          sx={{
            backgroundColor: "#2B6CB0 !important",
            color: "#FFFFFF !important",
            "&:hover": {
              backgroundColor: "#2C5282 !important",
            },
          }}
        >
          {submitLoader ? (
            <>
              Saving...
              <CircularProgress size={16} sx={{ ml: 1, color: "white" }} />
            </>
          ) : (
            warnActiveSubs ? (
              "Save & publish"
            ) : (
              "Save changes"
            )
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SubmitConfirmation;
